import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { withRouter } from 'kts-platform-frame/routes';
import { connect } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import qs from 'query-string';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { company, appStore } from 'kts-platform-frame/api';
import history from 'kts-platform-frame/routes/history';
import { message , Spin } from 'antd';
import UIAppError from './UI.AppError';
import UIAppBind from './UI.AppBind';
import UIPanel from './UI.Panel';
const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class  UIFrame extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        try {
            const search = qs.parse(window.location.search);
            const timeout = search.timeout as string;
            if(timeout) { //超时处理
                return;
            }
            const loginURL = search.loginURL as string;
            if(loginURL) {
                window['$$_thirdLogin'] = loginURL;
            }
            /*
            const companyName = search.companyName as string;
            const taxId = search.taxId as string;
            const userId = search.userId as string;
            const userName = search.userName as string; */
            const code = search.code as string;

            if (code) {
                /* const params = {appKey, company :{ name: companyName, taxId, } , thirdUserRequest: {outSideUserId: userId, nickName: userName} }; */
                this.getAppToken(code);
            } else {
                this.handleError();
            }
        } catch (error) {
            this.handleError();
        }
    }

    render() {
        return (
            <div className={css.iframe} >
                {this.modulesState.showModal? <UIPanel onSubmit={this.binding} onCancel={this.cancelBinding} />:
                <this.renderIframe />
                }
            </div>
        );
    }

    private renderIframe = () => {
        const  { appInfo, loading } = this.modulesState;
        const search = qs.parse(window.location.search);  
        const timeout = search.timeout as string;
        if(timeout) {
            return <UIAppError info="请重新登录或刷新页面。"/>;
        }else {
            return (
                <>
                    {
                        loading
                            ? <div className={css.loadingBox}> <Spin size="large" /></div>
                            : !appInfo ? <UIAppError /> : null
                    }
            </>
            );
        }
    }

    private setUserToken = (token: string, appKey: string)=>{
        const { user } = MyStore.instance.getState();
        user.cToken = token;
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user).then(() => {
            // 获取用户数据
            company.userInfo(this).then(userInfoData => {
                if (!userInfoData.er) {
                    let loginType = 'silent'; // 'default'
                    MyStore.instance.dispatch(reducers.system.ActionTypes.setLoginType, loginType).then(() => {
                        history.replace(`/workbench/m/${appKey}`); 
                        this.setGuideTipState();
                        this.handleWithToken();
                    });
                } else {
                    message.error('登录失败！');
                    setTimeout(()=> {
                        this.handleError();
                    }, 2000);
                }
            });
        });
    }
    /** 去除当前登录用户新手引导查看状态 */
    private setGuideTipState = () => {
        const guideVersionUser = JSON.parse(sessionStorage.getItem("guideVersionUser"));
        const { user } = MyStore.instance.getState();
        if (guideVersionUser && guideVersionUser[user.userInfo.gUserId]) {
            delete guideVersionUser[user.userInfo.gUserId];
        }
        sessionStorage.setItem("guideVersionUser", JSON.stringify(guideVersionUser));
    }
    private setLoading = (loading: boolean) => {
        this.modulesState.loading = loading;
        this.setModulesState();
    }
    /** 判断嵌入App的Token */
    private getAppToken = async (code: any): Promise<void> => {
        this.setLoading(true);
        //const resCode = await appStore.getAppCode(this, params);
        //const code = resCode.res;
        if(code) {
            const response = await appStore.getAppToken(this, { code } ) as any;
            const res = response.res;
            if(res && !response.er) {
                const { isBind , ticket, token, appKey , clientAppName } = res;
                if(isBind && token) { 
                    this.setUserToken(token, appKey);
                }else { //跳转授权登录页面
                    this.handleWithoutToken(ticket, clientAppName);
                }
            }else {
                //message.error(response.er.description);
                this.handleError();
            }
        }else {
            this.handleError();
        }
    }
    private binding = async (values: any)=>{
        const params = {
                identifier: values.username,
                credential: values.password,
                ticket: this.modulesState.bindTicket,
        };
        const response = await appStore.bindAuthorize(this, params) as any;
        if (!response.er && response.res) {
            const { token, appKey } = response.res;
            if(token) { 
                this.setUserToken(token, appKey);
            }else {
                this.cancelBinding();
            }
        } else {
            this.cancelBinding();
        }
    }
    private cancelBinding = ()=>{
        this.modulesState.showModal = false;
        this.handleError();
    }
    private handleWithToken = () => {
        this.modulesState.appInfo = true; //{ appType : 2 };
        this.modulesState.loading = false;
        this.setModulesState();
    }
    private handleWithoutToken = async (ticket: string, clientAppName?: string): Promise<void> => {
        const isIFrame = this.isIframe();
        if(isIFrame) { //嵌套页面不能添加授权页
            this.handleError(); 
        }else {
            this.modulesState.showModal = true;
            this.modulesState.bindTicket = ticket;
            this.modulesState.clientAppName = clientAppName;
            this.setModulesState();
        }   
    }
    private handleError = () => {
        this.modulesState.appInfo = null;
        this.modulesState.loading = false;
        this.setModulesState();
    }
    private isIframe = () => {
        return window['$$_self'] === 'iframe';
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/LoginThird/UI.Iframe.tsx